export const MAX_AMOUNT_DIGITS = 7;

export const round1 = (value: number) => Math.round(value * 10) / 10;

// Summary: Appends a keypad digit, capping the digit count and stripping a leading zero.
export const appendDigit = (buffer: string, digit: string): string => {
  const candidate = buffer + digit;
  if (candidate.replace('.', '').length > MAX_AMOUNT_DIGITS) return buffer;
  return candidate.replace(/^0(\d)/, '$1');
};

export const appendDot = (buffer: string): string => {
  if (buffer.includes('.')) return buffer;
  return buffer === '' ? '0.' : `${buffer}.`;
};

export const dropLastChar = (buffer: string): string => buffer.slice(0, -1);

// Summary: Reads the buffer as a 1-decimal amount; an empty/'.' buffer means 0.
export const bufferToAmount = (buffer: string): number => {
  const raw = buffer === '' || buffer === '.' ? 0 : Number(buffer);
  return Number.isFinite(raw) ? round1(raw) : NaN;
};
